import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AnalyticsEvent } from "@/types/analytics.types";

interface UseAnalyticsEventsOptions {
  limit?: number;
  eventName?: string;
  startDate?: string;
  endDate?: string;
}

export const useAnalyticsEvents = (options: UseAnalyticsEventsOptions = {}) => {
  const { limit = 50, eventName, startDate, endDate } = options;

  return useQuery({
    queryKey: ['analytics-events', limit, eventName, startDate, endDate],
    queryFn: async (): Promise<AnalyticsEvent[]> => {
      let query = supabase
        .from('analytics_events')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(limit);

      if (eventName) {
        query = query.eq('event_name', eventName);
      }

      if (startDate) {
        query = query.gte('created_at', startDate);
      }

      if (endDate) {
        query = query.lte('created_at', endDate);
      }

      const { data, error } = await query;

      if (error) throw error;

      return (data || []).map(event => ({
        ...event,
        properties: typeof event.properties === 'object' && event.properties !== null 
          ? event.properties as Record<string, any>
          : {},
      }));
    },
    refetchInterval: 10000, // Refetch every 10 seconds for live updates
  });
};
